window.Noren = (function () {
  const mount = document.getElementById('noren-mount');
  function show(cb) {
    if (!mount) { if (cb) cb(); return; }
    const label = (window.theme && window.theme.settings.norenLabel) || 'ようこそ';
    const el = document.createElement('div');
    el.className = 'noren';
    el.innerHTML = Array.from({ length: 8 }).map(()=>'<div class="noren-panel"></div>').join('') + '<div class="noren-text">' + label + '</div>';
    mount.appendChild(el);
    requestAnimationFrame(()=> el.classList.add('in'));
    setTimeout(function () {
      el.classList.remove('in'); el.classList.add('out');
      setTimeout(()=> el.remove(), 600);
      if (cb) cb();
    }, 950);
  }
  return { show: show };
})();
